import apiService from './ApiService';

const ProcesosService = {
  async getProcesos({ page = 1, pageSize = 10 } = {}) {
    return apiService.get(`/procesos?page=${page}&pageSize=${pageSize}`);
  },

  async marcarLeido(id) {
    return apiService.put(`/procesos/${id}/leido`, {});
  }
};

export default ProcesosService;
